module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Regular-WebS.5d5770f1.eot";